import { useState, useEffect } from 'react';

const LOGO_URL = 'https://storage.readdy-site.link/project_files/45018258-f3e7-4233-b9d2-d92b667091ad/e764bdcc-8c0e-413f-8889-ac7df88dbbe1_Logo-JM.jpeg?v=8304c19c9418a79c386ef5196d1910ad';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { label: 'Home', href: '/' },
    { label: 'About', href: '/#about' },
    { label: 'Industries', href: '/industries' },
    { label: 'Services', href: '/services' },
    { label: 'Why Us', href: '/why-us' },
    { label: 'Team', href: '/team' },
    { label: 'CSR', href: '/csr' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_1px_0_oklch(var(--foreground-900)/0.06)]'
          : 'bg-transparent'
      }`}
    >
      <div className="px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 z-10 flex-shrink-0">
            <div className="w-11 h-11 rounded-xl overflow-hidden flex-shrink-0 bg-background-100 border border-background-200">
              <img
                src={LOGO_URL}
                alt="Job Manifest"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="font-heading text-xl md:text-2xl font-bold tracking-tight text-foreground-900 whitespace-nowrap">
              Job Manifest
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="px-4 py-2 text-sm font-medium tracking-wide transition-all duration-300 rounded-full whitespace-nowrap text-foreground-700 hover:text-accent-500 hover:bg-accent-50"
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Right side - Apply Now + Contact Us */}
          <div className="hidden lg:flex items-center gap-3">
            <a
              href="/apply"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border-2 border-primary-500 text-primary-600 text-sm font-semibold whitespace-nowrap hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-file-list-3-line text-sm"></i>
              </span>
              Apply Now
            </a>
            <a
              href="/contact"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer"
            >
              Contact Us
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </span>
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden z-10 w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer text-foreground-800 hover:bg-background-200"
            aria-label="Toggle menu"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Mobile menu */}
        <div
          className={`lg:hidden overflow-hidden transition-all duration-400 ${
            mobileOpen ? 'max-h-[500px] pb-6' : 'max-h-0'
          }`}
        >
          <div className="flex flex-col gap-3 pt-2">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm font-medium tracking-wide text-foreground-700 hover:text-accent-500 transition-colors whitespace-nowrap py-1"
              >
                {item.label}
              </a>
            ))}
            <div className="pt-3 border-t border-foreground-100 flex flex-col gap-3">
              <a
                href="/apply"
                onClick={() => setMobileOpen(false)}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border-2 border-primary-500 text-primary-600 text-sm font-semibold whitespace-nowrap w-fit cursor-pointer"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-file-list-3-line text-sm"></i>
                </span>
                Apply Now
              </a>
              <a
                href="/contact"
                onClick={() => setMobileOpen(false)}
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap w-fit cursor-pointer"
              >
                Contact Us
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}